import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Box, Grid, Typography, TextField } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import {
  clearCompanyDuty,
  clearCompanyLocation,
  clearRateCard,
  clearSubCity,
  getCompanyDuty,
  getCompanyLocation,
  getRateCard,
  getSubCity,
} from "redux/actions/UserRateCard";
import { clearCar, getCar } from "redux/actions/UserCar";
import Loader from "components/loader/Loader";
import CommonEditableTable from "components/commonEditableTable/CommonEditableTable";
import { ratecardFilters } from "./RateCardData";
import { rateCardFiltersEnum } from "utils/enumObj";
import { clearCompanyDetails } from "redux/actions/companyAction";

function CompanyProfileRateCard({ type, disabled }) {
  const dispatch = useDispatch();
  const autoCompleteRef = useRef(null);
  const [subCityStatus, setSubCityStatus] = useState(3);

  //selectd Company city, duty type and vehicle
  const selectedCarData = useSelector((state) => state?.userCar?.userCar?.data);
  const selectedCityData = useSelector(
    (state) => state?.userCompanyLocation?.userCompanyLocation?.data
  );
  const selectedDutyTypeData = useSelector(
    (state) => state?.userCompanyDuty?.userCompanyDuty?.data
  );

  const subCityData = useSelector((state) => state?.userSubCity?.userSubCity?.data);

  const rateCardData = useSelector(
    (state) => state?.userRateCard?.userRateCard?.data
  );
  const loader = useSelector((state) => state?.userRateCard?.loading);
  const onboardedCompanyData = useSelector(
    (state) => state?.addCompany?.onBoardedCompay?.data
  );
  const onboardedUpdateCompanyData = useSelector(
    (state) => state?.updateCompany?.onBoardedCompay?.data
  );

  const companyProfile = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails
  );
  const contractId =
    companyProfile?.Contracts?.[0]?.CompanyContracts?.ContractId;

  const companyId =
    onboardedCompanyData?.id ||
    onboardedUpdateCompanyData?.Contracts?.[0]?.CompanyContracts?.CompanyId;

  const cityOptions =
    selectedCityData?.length > 0
      ? selectedCityData.map((val) => {
          return { name: val?.name, id: val?.id };
        })
      : [];

  const subCityOptions = subCityData?.length > 0
  ? subCityData?.map((val) => ({ name: val?.name, id: val?.id }))
  : [];

  const dutyOptions =
    selectedDutyTypeData?.length > 0
      ? selectedDutyTypeData?.map((val) => ({
          id: val.tripType,
          name: val.name,
        }))
      : [];

  const carOptions =
    selectedCarData?.length > 0
      ? selectedCarData?.map((val) => ({ id: val?.id, name: val?.carType }))
      : [];

  const [filterValues, setFilterValues] = useState({
    cityType: cityOptions?.length > 0 ? cityOptions?.[0] : "",
    dutyType: dutyOptions?.length > 0 ? dutyOptions?.[0] : "",
    carType: carOptions?.length > 0 ? carOptions?.[0] : "",
    subCityType: {id: "", name: ""},
  });

  useEffect(() => {
    if (
      cityOptions?.length > 0 &&
      dutyOptions?.length > 0 &&
      carOptions?.length > 0 && !filterValues?.carType?.id
    ) {
      const filterValueData = {
        cityType: cityOptions?.[0],
        dutyType: dutyOptions?.[0],
        carType: carOptions?.[0],
      };
      const data = {
        carType: filterValueData?.carType?.id,
        type: filterValueData?.dutyType?.id,
        baseFuelPrice: parseFloat(fuelBase),
        location: filterValueData?.cityType?.id,
        contractId: contractId,
      };
      dispatch(getRateCard(data));
    }
  }, [
    cityOptions?.[0]?.id,
    carOptions?.[0]?.id,
    dutyOptions?.[0]?.id,
  ]);


  //company Profile apicompanyProfile fetching
  useEffect(() => {
    if (companyProfile?.Contracts?.length) {
      dispatch(getCompanyLocation(contractId));
    }
  }, [companyProfile]);

  useEffect(() => {
    if (!filterValues?.dutyType?.id && cityOptions?.[0]?.id) {
      setFilterValues({ ...filterValues, cityType: cityOptions?.[0] });
      dispatch(
        getCompanyDuty({
          contractId: contractId,
          location: filterValues?.cityType?.id || cityOptions?.[0]?.id,
        })
      );
    }
  }, [cityOptions?.[0]?.id]);

  useEffect(() => {
    if (!filterValues?.dutyType?.id && dutyOptions?.[0]?.id) {
      setFilterValues({ ...filterValues, dutyType: dutyOptions?.[0] });

      if(dutyOptions?.[0]?.id === 4) {
        dispatch(getSubCity(cityOptions?.[0]?.id));
        setSubCityStatus(0);
      }
        dispatch(
          getCar({
            contractId: contractId,
            type: dutyOptions?.[0]?.id,
            location: cityOptions?.[0]?.id,
          })
        );
     
    }
  }, [dutyOptions?.[0]?.id]);

  useEffect(() => {
    if (carOptions?.[0]?.id) {
      setFilterValues({ ...filterValues, carType: carOptions?.[0] });
    }
  }, [carOptions?.[0]?.id]);

  useEffect(() => {
    return () => {
      dispatch(clearCompanyDetails());
      dispatch(clearCompanyDuty());
      dispatch(clearCompanyLocation());
      dispatch(clearRateCard());
      dispatch(clearCar());
      setFilterValues({
        ...filterValues,
        cityType: "",
        dutyType: "",
        carType: "",
      });
    };
  }, []);

  const fuelBasePrice = "102";
  const [fuelBase, setFuelBase] = useState(fuelBasePrice);

  useEffect(() => {
    const fuelPrice = rateCardData?.outStationRates?.length
      ? rateCardData?.outStationRates?.[0]?.baseFuelPrice
      : rateCardData?.rentalRate?.[0]?.baseFuelPrice
      ? rateCardData?.rentalRate?.[0]?.baseFuelPrice
      : rateCardData?.length  
      ? rateCardData?.[0]?.baseFuelPrice 
      : "";

    if (fuelPrice) {
      setFuelBase(fuelPrice);
    } else {
      setFuelBase(fuelBasePrice);
    }
  }, [rateCardData]);

  const handleChange = (newValue, name) => {

    const filterValuesData = filterValues;
    filterValuesData[name] = newValue;
    setFilterValues(filterValues);
    if (name === rateCardFiltersEnum?.cityType) {
      dispatch(
        getCompanyDuty({
          contractId: contractId,
          location: newValue?.id,
        }, "rateCard", setFilterValues, filterValuesData, setSubCityStatus)
      );
      dispatch(clearSubCity());

      if(filterValues?.dutyType?.id === 4) {
        dispatch(getSubCity(newValue?.id,  "rateCard", setFilterValues, filterValuesData))
      }
      setFilterValues({...filterValues, subCityType: {id: "", name: ""}});

  
    } else if (name === rateCardFiltersEnum?.dutyType) {

        setSubCityStatus(newValue?.id === 4 ? 0 :3);

      dispatch(
        getCar({
          contractId: contractId,
          type: newValue?.id,
          location: filterValues?.cityType?.id || cityOptions?.[0]?.id,
        }, "rateCard", setFilterValues, filterValuesData)
      );
      }
     else if ( name === rateCardFiltersEnum?.subCityType) {
      const data = {
        carType: filterValues?.carType?.id,
        type: filterValuesData?.dutyType?.id,
        baseFuelPrice: parseFloat(fuelBase),
        location: filterValuesData?.cityType?.id,
        contractId: contractId,
        subCity: filterValuesData?.subCityType?.id || ""
      };
      dispatch(getRateCard(data));

    }else if (name === rateCardFiltersEnum?.carType) {
      const data = {
        carType: newValue?.id,
        type: filterValuesData?.dutyType?.id,
        baseFuelPrice: parseFloat(fuelBase),
        location: filterValuesData?.cityType?.id,
        contractId: contractId,
        subCity: filterValuesData?.subCityType?.id || ""
      };
      dispatch(getRateCard(data));

    }
  };

  const handleOptions = (name) => {
    const options = {
      dutyType: dutyOptions,
      carType: carOptions,
      cityType: cityOptions,
      subCityType: subCityOptions
    };

    return options[name] || [];
  };

  return (
    <div>
      {loader ? (
        <Loader height={"50vh"} />
      ) : (
        <div className={`mt0`}>
          {type !== "companyProfile" && (
            <Typography
              variant="head3"
              component={"div"}
              className="colorBlack  fw600 alignItem"
            >
              Rate Card Details
            </Typography>
          )}

          {cityOptions?.length > 0 && (
            <Box>
              {/* ---Filter Section--- */}
              <Grid
                container
                gap={2}
                flexWrap={"nowrap"}
                className="mt0 justifyBetween flexRow"
              >
                {/* ---Filter Section--- */}
                <Grid
                  container
                  gap={2}
                  flexWrap={"nowrap"}
                  direction="row"
                  justifyContent="space-between"
                  alignitem="center"
                  className="mt30"
                >
                  {ratecardFilters &&
                    ratecardFilters?.filter((filterData) => filterData?.id !== subCityStatus).map((filterData, index) => (
                      <Grid
                        item
                        md={3}
                        sm={6}
                        xs={12}
                        key={index}
                        className="customAutoComplete rateCardAutocomplete"
                      >
                        <Autocomplete
                          popupIcon={<ExpandMoreRoundedIcon />}
                          value={filterValues[filterData?.name]}
                          onChange={(event, value) => {
                            handleChange(value, filterData?.name);
                          }}
                          disableClearable={filterData?.name !== "subCityType"}
                          disabled={filterData?.name === "subCityType" ? !subCityData?.length > 0 : false}
                          getOptionLabel={(option) => option.name}
                          id="controllable-states-demo"
                          options={handleOptions(filterData?.name) || []}
                          renderInput={(params) => (
                            <TextField {...params} inputRef={autoCompleteRef} />
                          )}
                        />
                      </Grid>
                    ))}
                  <Grid
                    item
                    container
                    md={3}
                    sm={6}
                    xs={12}
                    className="customAutocomplete rateCardBaseRate justifyCenter flexRow"
                  >
                    <Box item role="presentation" className="justifyCenter">
                      <Typography
                        variant="body3"
                        className="fw400"
                        sx={{ color: disabled ? "colorBlack" : "colorGrey" }}
                      >
                        Base Fuel Rate ₹
                      </Typography>
                      <Box item className="tableDis">
                        <input
                          type="number"
                          placeholder="Base Fuel"
                          role="presentation"
                          name="fuelBase"
                          id="input-with-icon-adornment"
                          value={fuelBase}
                          className={`baseFuelPrice colorBlack`}
                          disabled={true}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <CommonEditableTable
                type={type}
                rateCardData={rateCardData}
                locationData={filterValues?.cityType}
                companyId={companyId}
                trip={filterValues?.dutyType}
                disabled={disabled}
              />
            </Box>
          )}
        </div>
      )}
    </div>
  );
}

export default CompanyProfileRateCard;
